import { render } from "./DemoVideoModal.vue?vue&type=template&id=f8e6c784&scoped=true"
import script from "./DemoVideoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DemoVideoModal.vue?vue&type=script&setup=true&lang=js"

import "./DemoVideoModal.vue?vue&type=style&index=0&id=f8e6c784&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8e6c784"],['__file',"src/components/modals/DemoVideoModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f8e6c784"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f8e6c784', __exports__)) {
    api.reload('f8e6c784', __exports__)
  }
  
  module.hot.accept("./DemoVideoModal.vue?vue&type=template&id=f8e6c784&scoped=true", () => {
    api.rerender('f8e6c784', render)
  })

}


export default __exports__